import { globalStyles } from '@ctw/shared/content/document-viewer/_internal/renderers/pdf/pdf-cda-renderer';
import { PdfNodeRenderer } from '@ctw/shared/content/document-viewer/_internal/renderers/pdf/pdf-node-renderer';
import { isParsedTextNode, uniqueIdentifierForNode } from '@ctw/shared/utils/cda/helpers';
import type { CdaParsedHtmlElementNode } from '@ctw/shared/utils/cda/types';
import { Link } from '@react-pdf/renderer';
import { isEmpty } from 'lodash-es';
import { memo } from 'react';

interface PdfLinkRendererProps {
  id: string;
  link: CdaParsedHtmlElementNode;
}

export const PdfLinkRenderer = memo(({ id, link }: PdfLinkRendererProps) => {
  const href = link.attributes.href?.trim();

  if (isEmpty(href)) {
    return <></>;
  }

  const childrenIsSoloTextElement =
    link.childNodes.length === 1 && isParsedTextNode(link.childNodes[0]);

  return (
    <Link style={[globalStyles.link, link.styles.pdfStyles]} src={href}>
      {childrenIsSoloTextElement &&
        isParsedTextNode(link.childNodes[0]) &&
        link.childNodes[0].textContent}
      {!childrenIsSoloTextElement &&
        link.childNodes.map((child) => (
          <PdfNodeRenderer
            id={uniqueIdentifierForNode({ node: child, context: id, purpose: 'link-child' })}
            key={uniqueIdentifierForNode({ node: child, context: id, purpose: 'link-child' })}
            node={child}
          />
        ))}
    </Link>
  );
});
